import React from 'react'
import TypeWriterEffect from 'react-typewriter-effect';
function Typewriter() {
  return (
   <div className='flex w-full lg:h-[550px] md:h-[500px] sm:h-[300px] h-[200px] items-center justify-center'
    data-aos="fade-right"
    data-aos-duration="1000"
    >
    <h2 className='bg-clip-text text-transparent bg-gradient-to-r from-red-500 via-yellow-500 to-blue-500 text-[16px] font-bold md:text-4xl lg:text-6xl text-center gap-[8px] mt-[20px] mb-[40px] flex  sm:text-2xl p-4'>
        Hello, I am 
    <TypeWriterEffect
    textStyle={{
    //   fontFamily: 'Red Hat Display',
      color: '#ced900',
      fontWeight: 700,
    //   fontSize: '1.5em',
    }}
    startDelay={1000}
    cursorColor="#ced900"
    multiText={[
        'Habibur Rahman',
        'React Developer',
        'Front-End Developer',
        'Programmer',
      ]}
      multiTextDelay={2000}
      typeSpeed={50}
      multiTextLoop
  />
    </h2>
   </div>

  )
}

export default Typewriter